"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MineralDeposit = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
class MineralDeposit extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.MINERAL_DEPOSIT,
            cost: 5,
            metadata: {
                cardNumber: '062',
                renderData: CardRenderer_1.CardRenderer.builder((b) => b.steel(5).digit),
                description: 'Gain 5 steel.',
            },
        });
    }
    play(player) {
        player.steel += 5;
        return undefined;
    }
}
exports.MineralDeposit = MineralDeposit;
//# sourceMappingURL=MineralDeposit.js.map